import * as React from "react";
import { merge, $ } from "glamor";
import { DATATEST } from "../../../constants/integration";

interface IBackgroundSlide {
    image: string;
}

interface IBackgroundSlideState {
    showing: boolean;
}

export class Slide extends React.Component<IBackgroundSlide, IBackgroundSlideState> {
    unmounted = false;

    styles = merge(
        {
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            background: "center / cover",
            opacity: 0,
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
        },
        $(".showing", {
            opacity: 1,
        })
    );

    constructor(props) {
        super(props);
        this.state = {
            showing: false,
        };
    }

    componentDidMount() {
        this.unmounted = false; // set false explicitly. no undefined
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    componentWillAppear(callback) {
        this.setState({ showing: true });
        callback();
    }

    componentWillEnter(callback) {
        setTimeout(() => {
            // strict check that value is set
            if (this.unmounted === false) {
                this.setState({ showing: true });
            }
        }, 20); // matches transition duration

        setTimeout(() => {
            // strict check that value is set
            if (this.unmounted === false) {
                callback();
            }
        }, 470); // matches transition duration
    }

    componentWillLeave(callback) {
        this.setState({
            showing: false,
        });

        setTimeout(() => {
            if (!this.unmounted) {
                callback();
            }
        }, 450); // matches transition duration
    }

    render() {
        const { image } = this.props;
        const { showing } = this.state;
        return (
            <div
                data-test={DATATEST.LOGIN.BACKGROUND_SLIDER}
                {...this.styles}
                className={showing ? "showing" : undefined}
                style={{
                    backgroundImage: `url(${image})`,
                }}
            />
        );
    }
}

export default Slide;
